import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Grid,
  ClickAwayListener,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import Snakbar from "../../../components/SnakBar";
import I18n from "../../../config/locales";
import icon from "../Icons/pronto.svg";
import { useHistory } from "react-router-dom";
import validatedIcon from "../Icons/validated.png";
import infoIcon from "../Icons/onboarding.png";
import Refresh from "../Icons/refreshIcon";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "0px 0px 8px #00000029",
    marginTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(0.25),
    minHeight: "90px"
  },
  newFeature: {
    width: "20%",
    background: "#f37321",
    padding: theme.spacing(0.2),
    color: "white",
    textAlign: "center",
    fontSize: "small",
    borderRadius: "0 0 12px 0",
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      width: "40%",
    },
    [theme.breakpoints.up("xs")]: {
      width: "35%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "30%",
    }, [theme.breakpoints.up("md")]: {
      width: "30%",
    }, [theme.breakpoints.up("lg")]: {
      width: "20%",
    },
  },
  logo: {
    maxWidth: theme.spacing(4.5),
    maxHeight: theme.spacing(4.5),
    verticalAlign: "middle",
    margin: "auto",
    textAlign: "center",
    width: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
  },
  scoreCardWrapper: {
    position: "relative",
    padding: theme.spacing(0.25, 1, 1, 1),
  },
  displayFlex: {
    display: "flex",
    // paddingTop: theme.spacing(0.6)
    justifyContent: "center",
  },
  text: {
    padding: theme.spacing(1),
    fontSize: "smaller",
    color: "#4B4B4B",
  },
  gridContainer: {
    alignItems: "center",
  },
  prontoButton: {
    height: theme.spacing(3),
    minWidth: theme.spacing(18),
    // maxWidth: theme.spacing(20),
    lineHeight: theme.spacing(0),
    border: "1px solid #f37321",
    // fontWeight: "700",
    // fontSize: "x-small", 
    backgroundColor: "#f37321",
    color: "white",
    borderRadius: "5px",
    fontFamily: "Roboto",
    cursor: "pointer",
    fontSize: "12px"
  },
  statusIcons: {
    width: "17px",
    verticalAlign: "bottom",
    paddingLeft: "6px",
  },
  tooltip: {
    background: theme.palette.primary.white,
    boxShadow:
      "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
    minWidth: theme.spacing(45),
    fontSize: "12px",
    pointerEvents: "auto",
    color: "black",
    padding: theme.spacing(1.5),
    justifyContent: "center",
    // left: `-${theme.spacing(3.75)}px`,
    [theme.breakpoints.down("sm")]: {
      // left: 0,
      minWidth: theme.spacing(21.25),
      width: theme.spacing(35),
    },
  },
  tooltipWithPadding: {
    padding: theme.spacing(1.5, 4),
  },
  tooltip1: {
    marginTop: theme.spacing(-3),
    // marginLeft: theme.spacing(1.25),
    fontSize: "11px",
    // padding: theme.spacing(0.5, 1.5),
  },
  toolTipButton: {
    border: "1px solid #e2e2e2",
    boxShadow: "0px 1px 4px 0px #c8c8c869",
    borderRadius: "19px",
    padding: "1px 11px !important",
    margin: "4px 4px"
  },
  refreshButton: {
    float: "right",
    padding: "5px",
    marginRight: "10px",
    color: "grey",
    width: "20px",
    height: "20px",
  },
  buttonDisabled: {
    backgroundColor: "#c7c7c7",
    border: "#c7c7c7",
    cursor: "not-allowed",
  },
  loadingMessage: {
    padding: "15px",
    textAlign: "center",
    opacity: "0.6"
  },
  textHead: {
    fontWeight: "700"
  }
}));

const Pronto = (props) => {
  const {
    refreshProntoStatus,
    showError,
    messageType,
    message,
    refreshLoading,
    providerStatusDetails,
    loadingFailed,
  } = props;
  const classes = useStyles();

  const [showStatusDescription, setStatusDescriptionTooltip] = useState(false);
  const [showdisableButtonDescription, setDisableButtonDescriptionTooltip] = useState(false);
  const [showRefreshButtonInfo, setShowRefreshButtonInfo] = useState(false);
  const iconLink = {
    // ONBOARDING: infoIcon,
    // PENDING_VALIDATION: infoIcon,
    // OUT_OF_COMPLIANCE: infoIcon,
    VALIDATED: validatedIcon,
    // DECLINED: infoIcon,
    // NEEDS_VALIDATION: infoIcon,
    OTHERS: infoIcon
  };

  const statusVal = {
    ONBOARDING: "Onboarding",
    PENDING_VALIDATION: "Pending Validation",
    OUT_OF_COMPLIANCE: "Out of Compliance",
    VALIDATED: "Validated",
    DECLINED: "Declined",
    NEEDS_VALIDATION: "Needs Validation",
    ARCHIVED: "Archived"
  };

  const isNewUser = providerStatusDetails.provider_id ? false : true;
  const isViewOnlyAdmin = providerStatusDetails
    ? providerStatusDetails.success === false &&
      providerStatusDetails.provider_id !== null
      ? true
      : false
    : false;

  let history = useHistory();

  const signUpNavigate = () => {
    let path = `dashboard/pronto`;
    history.push(path);
  };

  useEffect(() => {
    refreshProntoStatus();
  }, []);

  return (
    <React.Fragment>
      {showError && <Snakbar message={message} severity={messageType} />}
      <Box className={classes.root}>
        <Grid container>
          <Grid item xs={10}>
            <Box className={classes.newFeature}>
              {I18n.t("dashboard.newFeature")}
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box>

              {<ClickAwayListener
                onClickAway={() => setShowRefreshButtonInfo(false)}
              >
                <Tooltip
                  open={showRefreshButtonInfo}
                  title={I18n.t("dashboard.refreshStatus")}
                  onMouseEnter={(e) => setShowRefreshButtonInfo(true)}
                  onMouseOut={(e) => setShowRefreshButtonInfo(false)}
                  placement="bottom"
                  classes={{ tooltip: classes.tooltip1 }}
                >
                  <div>
                    {!refreshLoading && <Refresh
                      className={`${classes.refreshButton} ${classes.toolTipButton}`}
                      onClick={() => { setShowRefreshButtonInfo(false); refreshProntoStatus() }}
                      style={{ "cursor": "pointer" }}
                    />}
                  </div>
                </Tooltip>
              </ClickAwayListener>}


              {refreshLoading && (
                <CircularProgress className={classes.refreshButton} size={16} />
              )}
            </Box>
          </Grid>
        </Grid>
        {refreshLoading && (
          <Box
            className={`${classes.scoreCardWrapper} ${classes.text} ${classes.loadingMessage} `}
          >
            Loading....
          </Box>
        )}
        {!refreshLoading && loadingFailed && (
          <Box
            className={`${classes.scoreCardWrapper} ${classes.text} ${classes.loadingMessage} `}
          >
            {message}
          </Box>
        )}

        {isNewUser && !refreshLoading && !loadingFailed && (
          <Box className={classes.scoreCardWrapper}>
            <Grid container className={classes.gridContainer}>
              <Grid item xs={2}>
                <img src={icon} className={classes.logo} />
              </Grid>
              <Grid item xs={7} className={classes.text}>
                {I18n.t("dashboard.prontoSignupMessage")}
              </Grid>
              <Grid item xs={3} className={classes.displayFlex}>
                {providerStatusDetails && providerStatusDetails.success && (
                  <button
                    className={classes.prontoButton}
                    onClick={signUpNavigate}
                  >
                    {I18n.t("dashboard.prontoButton")}
                  </button>
                )}

                {providerStatusDetails && !providerStatusDetails.success && (
                  <ClickAwayListener
                    onClickAway={() =>
                      setDisableButtonDescriptionTooltip(false)
                    }
                  >
                    <Tooltip
                      open={showdisableButtonDescription}
                      title={providerStatusDetails.message ? providerStatusDetails.message : ''}
                      onMouseEnter={(e) =>
                        setDisableButtonDescriptionTooltip(true)
                      }
                      onMouseOut={(e) =>
                        setDisableButtonDescriptionTooltip(false)
                      }
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <button className={`${classes.prontoButton}  disabled`}>
                        {I18n.t("dashboard.prontoButton")}
                      </button>
                    </Tooltip>
                  </ClickAwayListener>
                )}
              </Grid>
            </Grid>
          </Box>
        )}
        {!isNewUser && !refreshLoading && !loadingFailed && (
          <Box className={classes.scoreCardWrapper}>
            <Grid container className={classes.gridContainer}>
              <Grid item xs={2}>
                <img src={icon} className={classes.logo} />
              </Grid>
              <Grid item xs={10} sm={10} md={7} className={classes.text}>
                <Grid container>
                  <Grid item xs={5} sm={5} md={7} lg={4} className={classes.textHead}>
                    365 Pronto ID
                  </Grid>
                  <Grid item >:&nbsp;
                    {providerStatusDetails.provider_id}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={5} sm={5} md={4} lg={4} className={classes.textHead}>
                    Status
                  </Grid>
                  <Grid item style={!statusVal[providerStatusDetails.data.status] ? { textTransform: 'capitalize' } : {}}>:&nbsp;
                    {statusVal[providerStatusDetails.data.status]
                      ? statusVal[providerStatusDetails.data.status]
                      : providerStatusDetails.data.status.toLowerCase()}
                    <ClickAwayListener
                      onClickAway={() => setStatusDescriptionTooltip(false)}
                    >
                      <Tooltip
                        open={showStatusDescription}
                        title={providerStatusDetails.data.statusText ? providerStatusDetails.data.statusText : I18n.t("dashboard.defaultStatusText")}
                        onMouseEnter={(e) => setStatusDescriptionTooltip(true)}
                        onMouseOut={(e) => setStatusDescriptionTooltip(false)}
                        classes={{ tooltip: classes.tooltip }}
                      >
                        <img
                          src={iconLink[providerStatusDetails.data.status] ? iconLink[providerStatusDetails.data.status] : iconLink['OTHERS']}
                          className={classes.statusIcons}
                        />
                      </Tooltip>
                    </ClickAwayListener>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3} className={classes.displayFlex}>
                {!isViewOnlyAdmin && (
                  <button
                    className={classes.prontoButton}
                    onClick={() => {
                      window.open(
                        `https://${providerStatusDetails.data.registrationLink}`,
                        "_blank"
                      );
                    }}
                  >
                    {I18n.t("dashboard.prontoButton")}
                  </button>
                )}
                {isViewOnlyAdmin && (
                  <ClickAwayListener
                    onClickAway={() =>
                      setDisableButtonDescriptionTooltip(false)
                    }
                  >
                    <Tooltip
                      open={showdisableButtonDescription}
                      title={providerStatusDetails.message ? providerStatusDetails.message : ""}
                      onMouseEnter={(e) =>
                        setDisableButtonDescriptionTooltip(true)
                      }
                      onMouseOut={(e) =>
                        setDisableButtonDescriptionTooltip(false)
                      }
                      classes={{ tooltip: `${classes.tooltip} ${classes.tooltipWithPadding}` }}
                    >
                      <button
                        className={`${classes.prontoButton}  ${classes.buttonDisabled}`}
                      >
                        {I18n.t("dashboard.prontoButton")}
                      </button>
                    </Tooltip>
                  </ClickAwayListener>
                )}
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  belongsToUs: state.appReducer.belongsToUs,
  companyId: state.appReducer.companyId,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  featureList: state.appReducer.featureList,
  providerStatusDetails: state.prontoReducer.providerStatusDetails,
  showError: state.prontoReducer.showError,
  messageType: state.prontoReducer.messageType,
  message: state.prontoReducer.message,
  refreshLoading: state.prontoReducer.refreshLoading,
  loadingFailed: state.prontoReducer.loadingFailed,
});

export default connect(mapStateToProps)(Pronto);
